import { Component } from 'preact';
import ploneApi from 'api/PloneApi';

import ThreeWrapper from 'async!./ThreeWrapper';
import Spinner from 'components/Spinner';

export default class PanoramaStarter extends Component {
    constructor(props) {
        super(props)

        this.state = {
            panoramaPoints: {}
        }
    }

    componentDidMount() {
        ploneApi.fetch("@search?portal_type=panorama-point&fullobjects=1")
            .then(data => {
                let panPoints = this.state.panoramaPoints;
                data.items.forEach(item => {
                    item["referenced-panoramas"].forEach(panorama => {
                        const panId = panorama["@id"];
                        if(panPoints.hasOwnProperty(panId)) {
                            panPoints[panId].push(item);
                        } else {
                            panPoints[panId] = [item];
                        }
                    });
                });
                this.setState({
                    panoramaPoints: panPoints
                })
            });
    }

    render() {
        const panoramaPoints = this.state.panoramaPoints.hasOwnProperty(this.props.item["@id"]) ? this.state.panoramaPoints[this.props.item["@id"]] : [];
        return (
            <div>
                <Spinner />
                <ThreeWrapper item={this.props.item}
                               panoramaPoints={panoramaPoints}
                               panoramaFunctions={this.props.panoramaFunctions}
                               runRenderer={this.props.runRenderer} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./components/Panorama/PanoramaStarter.jsx